
// this file is auto generated
// the current version is:
module.exports = "3.0.3";
